// extracted by mini-css-extract-plugin
export default {"link":"wK-z","disabled":"xK-z"};